import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import DropdownApi from '../../components/DropdownApi';
import { UserSession } from '../../models/UserSession';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import { NprLookup } from '../../service/api-service';
import S3ImagePreview from '../../components/S3ImagePreview';
import { Avatar } from 'primereact/avatar';
import { placeholder } from '../../assets/placeholder';
import MultiDropdownApi from '../../components/MultiDropdownApi';
import ImageS3Upload from '../../components/ImageS3Upload';
import { v4 as uuid } from 'uuid';
import { addEquipment, updateEquipment } from '../../service/equipmentService';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Grid } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import IntervalDropdown from '../../components/IntervalDropdown';
import { add, update } from '../../service/equipmentListService';
import { addRiskJobStep, addRiskJobTask, updateRiskJobStep, updateRiskJobTask } from '../../service/riskAssessmentService';

export default function RiskJobStepAdd(modalProps: any) {

  const details = modalProps?.details;

  const client_id = modalProps?.client;

  const id = modalProps?.uuid;

  async function Add() {
    let updateDetails: any = {
      name,
      description,
      job_task: jobTask,
      hazard
    };
    modalProps.setGlobalLoading(true);
    if (modalProps.id) {
      updateRiskJobStep(updateDetails, modalProps.id).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Risk Step Updated Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      }).catch((error) => {
        modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Updated Risk Step', life: 3000 });
        modalProps.setGlobalLoading(false);
      })
    } else {
      if (client_id) {
        updateDetails.client_id = client_id;
      }
      addRiskJobStep(updateDetails).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Risk Step Created Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      }).catch((error) => {
        modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Create Risk Step', life: 3000 });
        modalProps.setGlobalLoading(false);
      })
    }
  }



  const [name, setName] = React.useState(details?.name || "");
  const [description, setDescription] = React.useState(details?.description || "");
  const [jobTask, setJobTask] = React.useState(details?.job_task || []);
  const [hazard, setHazard] = React.useState(details?.hazard || []);

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Name<div style={{ color: 'red' }}>*</div></FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={name} onChange={(e) => setName(e.target.value)} type="text" className="p-inputtext-sm PrimeSmallInput" />
            </FormControl>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Description</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputTextarea value={description} placeholder="Description" onChange={e => setDescription(e.target.value)} />
            </FormControl>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <MultiDropdownApi
            apiPath="risk-hazard"
            optionLabel="name"
            optionValue="id"
            label="Hazard"
            selectedData={hazard}
            setSelectedData={setHazard}
          />
        </Grid>

        <Grid item xs={12}>
          <MultiDropdownApi apiPath='risk-job-task' optionLabel="task_name" optionValue='id' label='Job Task' selectedData={jobTask} setSelectedData={setJobTask} showAll={true} />
        </Grid>
        <br />
      </Grid>
      <br /><br />
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => Add()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}